import api from '../../utils/api';

export const login = async (credentials) => {
  const response = await api.post('/auth/login', credentials);
  const resData = response.data;
  return { token: resData.token, user: resData.data };
};

export const register = async (userData) => {
  const response = await api.post('/auth/register', userData);
  const resData = response.data;
  return { token: resData.token, user: resData.data };
};

export const getMe = async () => {
  const response = await api.get('/auth/me');
  return { user: response.data.data };
};

export const updateProfile = async (profileData) => {
  const response = await api.put('/auth/profile', profileData);
  return { user: response.data.data };
};

export const changePassword = async (passwordData) => {
  const response = await api.put('/auth/change-password', passwordData);
  return response.data;
};

export const forgotPassword = async (email) => {
  const response = await api.post('/auth/forgot-password', { email });
  return response.data;
};

export const resetPassword = async (token, password) => {
  const response = await api.post(`/auth/reset-password/${token}`, { password });
  return response.data;
};

export const logout = async () => {
  const response = await api.post('/auth/logout');
  return response.data;
};
